import { render, staticRenderFns } from "./ProjectField.vue?vue&type=template&id=bc463560&scoped=true&"
import script from "./ProjectField.vue?vue&type=script&lang=js&"
export * from "./ProjectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc463560",
  null
  
)

export default component.exports